// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"8ec9d467","304":"e777c801","419":"64dfd0d4","537":"4301f4f9","554":"987fc882","602":"9cbc6ec0","726":"842ca346","753":"f7824160","755":"28753ff8","774":"0dd6b4bd","857":"3244d42b","858":"7690aaee","883":"3bac5f82","895":"8c8d951a"}[chunkId] + ".chunk.js";
};